import React from 'react';

export const Row = ({
  slots: { owner, stakes, value, acqCost, profit, share },
  component: Component,
  ...rest
}: {
  slots: {
    owner: React.ReactNode;
    stakes: React.ReactNode;
    value: React.ReactNode;
    acqCost: React.ReactNode;
    profit: React.ReactNode;
    share: React.ReactNode;
  };
  // any is expected here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ElementType<any, 'td' | 'th'>;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement>) => {
  return (
    <tr {...rest}>
      <Component>{owner}</Component>
      <Component>{stakes}</Component>
      <Component>{value}</Component>
      <Component>{acqCost}</Component>
      <Component>{profit}</Component>
      <Component>{share}</Component>
    </tr>
  );
};
